import { EmployeeApi } from 'api/EmployeeApi';
import { Employee } from 'model/Employee';
import dayjs from 'dayjs';
import { mapClassificationDateModelToDto } from 'api/dto/ClassificationDate.dto';
import { ClassificationDto, mapClassificationDtoToModel } from 'api/dto/Classification.dto';
import { DepartmentDto } from 'api/dto/Department.dto';

export class EmployeeMapper {
  constructor() {}

  serialize(model: Employee): EmployeeApi.Entry {
    return {
      id: model.id,
      firstName: model.firstName,
      lastName: model.lastName,
      email: model.email,
      customAccessCode: model.accessCode,
      preferredLanguage: model.preferredLanguage,
      department: model.department as number,
      demographyClassifications: model.classifications as number[],
      classificationValues: model.classificationsDate.map((item) =>
        mapClassificationDateModelToDto(item),
      ),
      active: model.active ? 1 : 0,
    };
  }

  deserialize(entry: EmployeeApi.Entry): Employee {
    return {
      id: entry.id,
      firstName: entry.firstName,
      lastName: entry.lastName,
      email: entry.email,
      accessCode: entry.customAccessCode,
      preferredLanguage: entry.preferredLanguage,
      department: entry.department ? (entry.department as DepartmentDto).id : undefined,
      departmentNestedName: entry.departmentNestedName,
      surveyMethod: entry.email ? 'email' : 'kiosk',
      classifications: entry.demographyClassifications
        ? (entry.demographyClassifications as any).map((classification: ClassificationDto) =>
            mapClassificationDtoToModel(classification, entry.classificationValues),
          )
        : [],
      active: Boolean(entry.active),
      createdAt: entry.createdAt ? dayjs(entry.createdAt) : undefined,
      invitedAt: entry.invitedAt ? dayjs(entry.invitedAt) : undefined,
      pulseLifecycleProjects:
        entry.lifecycleSurveys?.map((elem) => ({
          type: elem.type,
          createdAt: dayjs.utc(elem.createdAt),
        })) ?? [],
    };
  }
}
